import { Box, SxProps, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import { SearchToggleButton } from "components/domains/search"
import { SearchIcon as DefaultSearchIcon } from "components/icons"
import { useAppUI } from "providers/ui"
import { useTranslation } from "providers/i18n"
import { HomeButton } from "components/Button/HomeButton"
import { useNavigate } from "react-router-dom"
import { BackButton } from "components/Button/BackButton"

interface IBottomSidebarActionProps {
  sx?: SxProps
}

export const BottomSidebarAction = ({ sx = {} }: IBottomSidebarActionProps) => {
  const { openSearch, goBack } = useAppUI()
  const { t } = useTranslation()
  const theme = useTheme()
  const { root, backButton, homeButton, searchButton } =
    theme.components[`BottomSidebarAction`]?.styleOverrides || {}

  const navigate = useNavigate()
  const handleHomeClick = () => {
    navigate("/maps")
  }

  return (
    <Box sx={deepmerge(root, sx)}>
      <BackButton onClick={goBack} sx={backButton} />
      <HomeButton onClick={handleHomeClick} sx={homeButton} />
      <SearchToggleButton
        icon={DefaultSearchIcon}
        sx={searchButton}
        placeholder={t("search")}
        onClick={openSearch}
      />
    </Box>
  )
}
